export const WALLET_ERROR_PATH = '/wallet-error'

const WALLET_ERROR_STORAGE_KEY = 'elephant_wallet_error'

export interface WalletErrorDetails {
  operation: 'connect' | 'disconnect'
  walletName: string
  message: string
  stack?: string
}

export function saveWalletError(
  operation: WalletErrorDetails['operation'],
  walletName: string,
  error: unknown
): void {
  const normalizedError = error instanceof Error ? error : new Error(String(error))
  const details: WalletErrorDetails = {
    operation,
    walletName,
    message: normalizedError.message,
    stack: normalizedError.stack,
  }

  try {
    window.sessionStorage.setItem(WALLET_ERROR_STORAGE_KEY, JSON.stringify(details))
  } catch (storageError) {
    console.debug('Unable to persist wallet error details', storageError)
  }
}

export function getWalletError(): WalletErrorDetails | undefined {
  try {
    const storedError = window.sessionStorage.getItem(WALLET_ERROR_STORAGE_KEY)
    if (!storedError) return undefined
    return JSON.parse(storedError) as WalletErrorDetails
  } catch {
    return undefined
  }
}

export function clearWalletError(): void {
  try {
    window.sessionStorage.removeItem(WALLET_ERROR_STORAGE_KEY)
  } catch (storageError) {
    console.debug('Unable to clear wallet error details', storageError)
  }
}
